<template>
  <svg
    class="ui-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
  >
    <path d="M5 19 19 5M5 5h14v14" />
  </svg>
</template>
<script>
export default { name: 'ArrowIcon' };
</script>
